export default __webpack_public_path__ + "static/media/Bedford_0067.bec5d0db.jpg";